<template>
  <div>
    <el-dialog custom-class="customDialog" :close-on-click-modal="false" :visible.sync="showModal"
      :width="labelWidth === '210px' ? '70%' : '100%'" :close-on-press-escape="false" :show-close="false" top="4vh"
      append-to-body @open="opened()">

      <div class="d-flex justify-content-between">
        <h3>{{$t('Müraciət')}}</h3>
        <h3 align="center" v-if="timeShow" style="font-size:20px;margin-top: 0px;">

        </h3>
      </div>
      <el-form ref="policy" :model="item" :label-width="labelWidth" :label-position="labelPosition" size="small"
        :rules="rules" v-loading="loading">
        <hr width="100%" size="50" style=" margin-top: 0;position: relative;height: 1px;background: #F3EFE0;"
          align="center">
        <div v-if="standalone" class="d-flex flex-column">
          <div class="d-flex justify-content-between align-items-center">
            <div style="width: 250px;">
              <el-form-item :disabled="!found" label-width="80px">
                <el-input :disabled="found" :placeholder="$t('Dövlət_qeydiyyat_nişanı')"
                  @keyup.enter.native="focusSearch(searchRegNumber)" v-upper v-mask="'XXXXXXXXXXXX'"
                  v-model="searchRegNumber" size="small">
                  <template :disabled="!found" #append>
                    &nbsp;<el-button :disabled="found" class="primary" size="small" icon="el-icon-search"
                      @click="onsearch(searchRegNumber)" />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div class="text-left" style="min-width: 100px;">
              <!-- <div style="font-size:24pt;">{{ timer }}</div> -->
            </div>
          </div>
          <hr width="100%" size="50" style=" margin-top: 0;position: relative;height: 0.5px;background: #f5f4f3;"
            align="center">
          <div style="margin-top: 7px;">
            <el-checkbox @change="notFoundChange" v-model="found" :disabled="mode == 'Edit'" size="small">
              {{$t('Təyin_olunmayıb')}}
            </el-checkbox>
            <el-checkbox v-if="!found" @change="notFoundChange" v-model="regNumberChange" size="small">
              {{$t('DQN_dəyişilib')}}
            </el-checkbox>

          </div>
        </div>
        <br />

        <h6 v-if="!found">{{$t('Sığortalının_məlumatları')}}</h6>
        <div v-if="!found" class="row">
          <div class="col-md-6 col-12">
            <el-form-item prop="regNumber" for="regNumberInput" v-if="!found" :label="$t('DQN')">
              <el-input v-upper v-model="item.regNumber" id="regNumberInput" :placeholder="$t('DQN')"
                :readonly="notfound && standalone">
              </el-input>
            </el-form-item>
            <el-form-item prop="insuredName" for="insuredNameInput" v-if="!found" :label="$t('Sığortalı')">
              <el-input v-upper v-model="item.insuredName" id="insuredNameInput" :placeholder="$t('ASA')"
                :readonly="notfound && standalone">
              </el-input>
            </el-form-item>
            <el-form-item v-if="!found" prop="compulsoryPeriod">
              <span :style="compulsoryPeriod == '' ? 'color:#c0c4cc' : ''" slot="label">
                {{$t('İCBARİ')}}
              </span>

              <el-input :disabled="compulsoryPeriod == ''"
                :placeholder="compulsoryPeriod == '' ? $t('Mövcud_deyil') : $t('SŞ_Başlama_Bitmə_tarixi')"
                v-model="compulsoryPeriod" :readonly="notfound && standalone">
                <template v-if="(compulsaryWarn && compulsoryPeriod)" v-slot:suffix>
                  <i :title="$t('Qüvvədə_deyil')" style="color:red" class="fa-solid fa-triacle-exclamation fa-2xl"></i>
                </template>
              </el-input>

              <p :class="statusClass" style="font-size:8pt;margin-bottom: 0px;">
                {{ compulsoryStatus }}
              </p>
            </el-form-item>

          </div>
          <div class="col-md-6 col-12">
            <el-form-item v-if="regNumberChange" prop="oldRegNumber" :label="$t('Əvvəlki_DQN')">
              <el-input :placeholder="$t('Dövlət_qeydiyyat_nişanı')"
                @keyup.enter.native="focusSearch(item.oldRegNumber)" v-upper v-mask="'XXXXXXXXXXXX'"
                v-model="item.oldRegNumber" size="small" style="width: 100%;">
                <span v-if="!found" slot="append">&nbsp;</span>
                <el-button v-if="!found" class="primary" slot="append" size="small" icon="el-icon-search"
                  @click="onsearch(item.oldRegNumber)">
                </el-button>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('Marka_model')" v-if="!found" prop="customBrandModel">
              <el-input v-model="item.customBrandModel" :readonly="notfound && standalone"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Telefon_nömrəsi')" v-if="!found" prop="phone">
              <el-input v-model="item.phone" :readonly="notfound && standalone" type="tel"
                :placeholder="$t('994_')" v-mask="'+994 (##) ###-##-##'" />
            </el-form-item>

            <el-form-item v-if="!found" prop="voluntaryPeriod">
              <span :style="voluntaryPeriod === '' ? 'color:#c0c4cc' : ''" slot="label">
                {{ $t('KASKO') }}
              </span>

              <el-input :disabled="voluntaryPeriod === ''"
                :placeholder="voluntaryPeriod === '' ? $t('Mövcud_deyil') : $t('Başlama_Bitmə_tarixi')"
                v-model="voluntaryPeriod" :readonly="notfound && standalone">
                <template v-if="voluntaryWarn && voluntaryPeriod" #suffix>
                  <i :title="$t('Qüvvədə_deyil')" style="color: red; cursor: pointer;"
                    class="fa-solid fa-triangle-exclamation fa-xl"></i>
                </template>
              </el-input>

              <p :class="statusClassVoluntary" style="font-size: 8pt; margin-bottom: 0; margin-top: 4px;">
                {{ voluntaryStatus }}
              </p>
            </el-form-item>
          </div>
        </div>
        <hr v-if="!found" width="100%" size="50"
          style="margin-top: 0; position: relative;height: 1px;background: #F3EFE0;" align="center">
        <h6>{{$t('Məlumat')}}</h6>
        <div class="row">
          <div v-if="!found" class="col-md-12 col-12">
            <el-form-item prop="driverNoInfo">
              <el-checkbox v-model="item.driverNoInfo">{{$t('Məlumat_yoxdur')}}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="item.driverNoInfo" prop="driverDescr" :label="$t('Qeyd')">
              <el-input v-model="item.driverDescr"></el-input>
            </el-form-item>
          </div>
          <div v-if="!item.driverNoInfo" class="col-md-6 col-12">
            <div v-if="found" class="row">
              <div class="col-md-12 col-12">
                <el-form-item prop="regNumber" :label="$t('DQN')">
                  <el-input :placeholder="$t('Dövlət_qeydiyyat_nişanı')" @keyup.enter.native="focusSearch" v-upper
                    v-mask="'XXXXXXXXXXXX'" v-model="item.regNumber" size="small" style="width: 100%;">
                    <!-- <span slot="append">&nbsp;</span>
                    <el-button :disabled="found" class="primary" slot="append" size="small" icon="el-icon-search"
                      @click="onsearch(item.regNumber)">
                    </el-button> -->
                  </el-input>

                </el-form-item>
              </div>
            </div>
            <div class="row">
              <div :class="!found ? 'col-md-9 col-12' : 'col-md-12 col-12'">
                <el-form-item :label="$t('Sürücü')" prop="driver">
                  <div>
                    <div style="right: 15px;" v-if="!found" class="col-md-3 col-12">
                      <el-checkbox @change="onIsInsured"
                        v-model="isInsured">{{$t('Sığortalı_ilə_eynidir')}}</el-checkbox>
                    </div>
                    <el-input v-upper v-letter :placeholder="$t('ASA')" v-model="item.driver" size="small">
                    </el-input>

                  </div>
                </el-form-item>
              </div>

              <div class="col-md-12 col-12">
                <div class="row">
                  <div :class="!found ? 'col-md-9 col-12' : 'col-md-12 col-12'">
                    <el-form-item :label="$t('Sürücünün_telefon_nömrəsi')" prop="driverPhone">
                      <div style="right: 15px;" v-if="!found" class="col-md-3 col-12">
                        <el-checkbox @change="onIsInsuredPhone"
                          v-model="isInsuredPhone">{{$t('Sığortalı_ilə_eynidir')}}</el-checkbox>
                      </div>
                      <phone v-model="item.driverPhone" />
                    </el-form-item>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-12">
            <el-form-item :label="$t('Sığorta_şirkəti')" v-if="found" prop="osOrg">
              <el-input v-model="item.orgName"></el-input>
            </el-form-item>

            <el-form-item :label="$t('Marka_model')" v-if="found" prop="customBrandModel">
              <el-input v-model="item.customBrandModel"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Əlavə_nömrə')" v-if="!item.driverNoInfo" prop="callPhone">
              <phone v-model="item.callPhone" />
            </el-form-item>
          </div>
        </div>
        <hr width="100%" size="50" style="margin-top: 10px; position: relative;height: 1px;background: #F3EFE0;"
          align="center">
        <h6>{{$t('Qarşı_tərəf')}}</h6>
        <div class="row">
          <div class="col-md-6 col-12">
          </div>
          <div class="col-md-6 col-12" style="margin-top: -30px;">
            <el-form-item :label="$t('NV_sayı')" prop="vehicleCount">
              <el-input-number v-model="item.vehicleCount" :min="1" :max="10" @change="addOppositeSide" />
            </el-form-item>
          </div>
        </div>
        <div>
          <div class="row" v-for="(item, index) in oppositeSide" :key="item.id"
            style="margin-left: 0;margin-right: 0;border: 1px solid #ccc;  margin-top: 10px;color: red;">
            <div class="col-md-6 col-12">
              <el-form-item prop="noInfo">

                <el-tag style="margin: 5px 0 0 0; transform: scale(0.8); transform-origin: top left;">
                  {{ index + 1 }}
                </el-tag>
              </el-form-item>
              <div style="margin-top: -15px;">
                <el-form-item prop="noInfo">

                  <el-checkbox :true-label="1" :false-label="0" :label="$t('Məlumat_verilməyib')"
                    v-model="item.noInfo"></el-checkbox>

                </el-form-item>
              </div>

            </div>
            <!-- <el-tag style="margin-left: -40px; margin-right: 10px; margin-top: 5px;">{{ index + 1 }}</el-tag> -->

            <div class="col-md-6 col-12" style="text-align: right;margin-top: 5px;">
              <el-button size="small" style="text-align: right" v-if="oppositeSide.length > 1"
                @click="deleteOppositeSide(index)"><i class="fa-solid fa-trash-can"></i></el-button>
            </div>
            <div v-if="!item.noInfo" class="col-md-6 col-12">
              <el-form-item :label="$t('DQN')" prop="opposite">
                <el-input :placeholder="$t('Dövlət_qeydiyyat_nişanı')" @keyup.enter.native="focusSearchOs(index)"
                  v-upper v-mask="'XXXXXXXXXXXX'" v-model="item.regNumber" size="small" style="width: 100%;">
                  <span slot="append">&nbsp;</span>
                  <el-button class="primary" :disabled="found" slot="append" size="small" icon="el-icon-search"
                    @click="onsearchOs(index)">
                  </el-button>
                </el-input>
              </el-form-item>
              <!-- <el-form-item :label="$t('Sığorta_şirkəti')" prop="orgName">
                <el-input v-model="item.orgName"></el-input>
              </el-form-item> -->
              <el-form-item :label="$t('Sığorta_şirkəti')" prop="insuranceCompId">
                <insurance-companies-el v-model="item.insuranceCompId"
                  @comp="item.orgName = $event"></insurance-companies-el>
              </el-form-item>

            </div>
            <div v-if="!item.noInfo" class="col-md-6 col-12">

              <el-form-item :label="$t('Marka_model')" prop="customBrandModel">
                <el-input v-model="item.customBrandModel"></el-input>
              </el-form-item>
              <el-form-item v-if="!found" prop="voluntaryPeriod">
                <span :style="item.voluntaryPeriod === '' ? 'color:#c0c4cc' : ''" slot="label">
                  {{ $t('KASKO') }}
                </span>

                <el-input :disabled="item.voluntaryPeriod === ''"
                  :placeholder="item.voluntaryPeriod === '' ? $t('Mövcud_deyil') : $t('Başlama_Bitmə_tarixi')"
                  v-model="item.voluntaryPeriod" :readonly="standalone">
                  <template v-if="Date.parse(item.volEndDate) < Date.parse(new Date()) && item.voluntaryPeriod" #suffix>
                    <i :title="$t('Qüvvədə_deyil')" style="color: red; cursor: pointer;"
                      class="fa-solid fa-triangle-exclamation fa-xl"></i>
                  </template>
                </el-input>

                <p style="color: red; font-size: 8pt; margin-bottom: 0; margin-top: 4px;">
                  {{ item.voluntaryStatus }}
                </p>
              </el-form-item>


            </div>

          </div>
        </div>
        <br>
        <hr v-if="!found" width="100%" size="50"
          style="margin-top: 0; position: relative;height: 1px;background: #F3EFE0;" align="center">
        <h6>{{$t('Hadisə_məlumatları')}}</h6>
        <div class="row">
          <div class="col-md-6 col-12">
            <el-form-item :label="$t('Hadisə_tarixi')" prop="accidentDate">
              <div :style="isAccidentOld ? { display: 'flex', alignItems: 'center' } : {}">
                <date-time-picker ref="datePicker" @input="inputDate" :optionDate="callDate"
                  :date="accidentDateValue.date" :time="accidentDateValue.time"></date-time-picker>
                <el-date-picker v-show="false" v-model="item.accidentDate"></el-date-picker>
                <el-button v-if="isAccidentOld" :title="$t('Gec_məlumat')"
                  style="padding: 0 !important; margin-left: 10px; font-size: 16pt;">
                  <div class="square-icon" style="color: red; font-size: 16pt">
                    <i class="fa-solid fa-exclamation"></i>
                  </div>
                </el-button>
              </div>
            </el-form-item>

            <el-form-item :label="$t('Ərazi')" prop="regionId">
              <regions v-model="item.regionId" @region="item.regionName = $event" />
            </el-form-item>
            <el-form-item :label="$t('Hadisə_yeri')" prop="place">
              <el-input v-model="item.place"></el-input>
            </el-form-item>
          </div>
          <div class="col-md-6 col-12">
            <el-form-item :label="$t('Zəncirvari_qəza')" prop="chainAccident">
              <el-radio-group v-model="item.chainAccident">
                <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('Bədən_xəsarəti')" prop="injured">
              <el-radio-group v-model="item.injured">
                <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('Əmlak')" prop="isProperty">
              <el-radio-group v-model="item.isProperty">
                <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('Heyvan')" prop="isAnimal">
              <el-radio-group v-model="item.isAnimal">
                <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item :label="$t('Ofisə_yaxınlaşıb')" prop="approachedOffice">
              <el-radio-group v-model="item.approachedOffice">
                <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- <el-divider></el-divider> -->

            <!-- <el-form-item :label="$t('Səhv_zəng')" prop="isWrongCall">
              <el-radio-group v-model="item.isWrongCall">
                <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
              </el-radio-group>
            </el-form-item> -->

          </div>

        </div>
        <div class="row">
          <div class="col-md-12 col-12">
            <el-form-item prop="descr" :label="$t('Qeyd')">
              <el-input v-model="item.descr"></el-input>
            </el-form-item>
          </div>
        </div>

        <!-- <span>
          {{$t('Sığortalı')}} : {{ item.regNumber }} {{ item.customBrandModel }}
          <br>
          Sürücü: {{ item.driver }} {{ item.driverPhone }}
          <br>
           {{$t('Qarşı_tərəf')}}  :
          <span>
            <span v-for="(opposite, index) in oppositeSide" :key="index">
              <span v-if="oppositeSide.length > 1">{{ index + 1 }}. </span>
              <span v-if="opposite.noInfo">{{$t('Məlumat_verilməyib')}}</span>
              <span v-else>
                {{ opposite.regNumber }}<span v-if="opposite.regNumber && opposite.customBrandModel">, </span>{{
                opposite.customBrandModel }}<span v-if="opposite.customBrandModel && opposite.orgName">, </span>{{
                opposite.orgName }}
              </span>
            </span>
          </span>
          <br>

          Hadisə yeri : {{ item.regionName }} {{ item.place }}
          <br>
          Qeyd : {{ item.descr }}
        </span> -->

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="clickSave">{{$t('Qeydə_al')}}</el-button>
        <el-button size="small" @click="clickReject">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('Xəbərdarlıq')" :visible.sync="recentAccidentDialog" width="30%">
      <span v-if="recentAccident"> "{{ recentAccident.regNumber }}" №-li DQN daha öncə sistemdə qeyd olunub.. </span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="recentAccidentDialog = false">{{$t('Bağla')}}</el-button> -->
        <el-button type="primary" v-if="recentAccident" @click="handleAccidentView()">Daha
          ətraflı</el-button>
      </span>
    </el-dialog>
    <accident-view ref="accident" />
  </div>
</template>

<script>
  import { AccidentType, PolicyStatusType } from "../../services/types";
  import { standalone, labelPosition } from "../../services/helper";
  import { mask } from "vue-the-mask";
  import Regions from "../components/Regions.vue";
  import {
    CreateAccident,
    UpdateAccident,
    GetAccident,
  } from "../../services/accident";
  import {
    PolicyStatusInsert,
    CreateOppositeSide,
    GetOppositeSide,
    GetOppositeSides,
    UpdateOppositeSide,
    DeleteOppositeSide,
    GetRecentAccident
  } from "../../services/common";
  import InsuranceCompaniesEl from '../components/InsuranceCompaniesEl.vue';
  import Phone from "../components/Phone.vue";
  import { DateTimeToJson, DateToString, DateTimeToString, DateTimeReverseToString } from "../../services/helper";
  import { salesapi, newsalesapi } from "../../services/sales";
  import DateTimePicker from "../components/DateTimePicker.vue";
  import AccidentView from "../callcenter/AccidentView.vue";
  // import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';

  // import GoogleMap from "../components/GoogleMaps";
  export default {
    directives: {
      mask,
    },
    components: {
      Phone,
      DateTimePicker,
      Regions,
      AccidentView,
      InsuranceCompaniesEl
      // DatePicker
    },
    computed: {
      isAccidentOld() {
        if (!this.item.accidentDate || !this.callDate) {
          return false; 
        }

        const accidentDateTime = new Date(this.item.accidentDate).getTime();
        const callDateTime = new Date(this.callDate).getTime();
        const millisecondsIn24Hours = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

        return callDateTime - accidentDateTime > millisecondsIn24Hours;
      },
      statusClass() {
        return {
          'text-success': this.compulsoryStatus === this.$t('Qüvvədədir'),
          'text-danger': this.compulsoryStatus === this.$t('Buraxılmış'),
          'text-warning': this.compulsoryStatus === this.$t('Qüvvəyə_minəcək'),
        };
      },
      statusClassVoluntary() {
        return {
          'text-success': this.voluntaryStatus === this.$t('Qüvvədədir'),
          'text-danger': this.voluntaryStatus === this.$t('Buraxılmış'),
          'text-warning': this.voluntaryStatus === this.$t('Qüvvəyə_minəcək'),
        };
      },
      notfound() {
        return !this.found;
      },

      voluntaryWarn() {
        if (Date.parse(this.item.volEndDate) < Date.parse(new Date)) return true
        return false
      },
      compulsaryWarn() {
        if (Date.parse(this.item.endDate) < Date.parse(new Date)) return true
        return false
      },
    },
    data() {


      var validateDate = (rule, value, callback) => {
        if (Date.parse(this.callDate) < Date.parse(this.item.accidentDate)) {
          callback(new Error(this.$t('Hadisə_tarixi_Zəngin_tarixindən_sonra_ola_bilməz')));
          return;
        }

        let isInStandardPeriod = this.item.startDate && this.item.endDate &&
          Date.parse(this.item.accidentDate) >= Date.parse(this.item.startDate) &&
          Date.parse(this.item.accidentDate) <= Date.parse(this.item.endDate);

        let isInVoluntaryPeriod = this.item.volStartDate && this.item.volEndDate &&
          Date.parse(this.item.accidentDate) >= Date.parse(this.item.volStartDate) &&
          Date.parse(this.item.accidentDate) <= Date.parse(this.item.volEndDate);

        if (isInStandardPeriod || isInVoluntaryPeriod || this.found) {
          callback();
        } else {
          callback(new Error(this.$t('Hadisə_tarixi_sığorta_müddətinə_aid_olmalıdır')));
        }
      };

      // var validateDate = (rule, value, callback) => {
      //   if (Date.parse(this.callDate) < Date.parse(this.item.accidentDate)) {
      //     callback(new Error(this.$t('Hadisə_tarixi_Zəngin_tarixindən_sonra_ola_bilməz')));
      //   } else if (
      //     this.item.startDate && !this.item.volStartDate &&
      //     (Date.parse(this.item.accidentDate) < Date.parse(this.item.startDate) ||
      //       Date.parse(this.item.accidentDate) > Date.parse(this.item.endDate))
      //   ) {
      //     callback(new Error(this.$t('Hadisə_tarixi_sığorta_müddətinə_aid_olmalıdır')));
      //   }
      //   else if (
      //     this.item.volStartDate && this.item.volStartDate &&
      //     (Date.parse(this.item.accidentDate) < Date.parse(this.item.volStartDate) ||
      //       Date.parse(this.item.accidentDate) > Date.parse(this.item.volEndDate))
      //   ) {
      //     callback(new Error(this.$t('Hadisə_tarixi_sığorta_müddətinə_aid_olmalıdır')));

      //   } else callback();
      // };

      // var validateDate = (rule, value, callback) => {
      //   const accidentDate = Date.parse(this.item.accidentDate);

      //   if (Date.parse(this.callDate) < accidentDate) {
      //     callback(new Error(this.$t('Hadisə_tarixi_Zəngin_tarixindən_sonra_ola_bilməz')));
      //   } else if (
      //     (this.item.startDate && this.item.endDate && (accidentDate < Date.parse(this.item.startDate) || accidentDate > Date.parse(this.item.endDate))) ||
      //     (this.item.volStartDate && this.item.volEndDate && (accidentDate < Date.parse(this.item.volStartDate) || accidentDate > Date.parse(this.item.volEndDate)))
      //   ) {
      //     callback(new Error(this.$t('Hadisə_tarixi_sığorta_müddətinə_aid_olmalıdır')));
      //   } else {
      //     callback();
      //   }
      // };


      return {
        searchRegNumber: "",
        labelPosition: labelPosition,
        regNumberChange: null,
        oppositeSide: [],
        nextId: null,
        timer: '00:00',
        timeBegan: null,
        timeStopped: null,
        stoppedDuration: 0,
        started: null,
        running: false,
        seconds: 0,
        buttonDisabled: false,
        stopButton: true,
        resetButton: true,
        timeShow: false,
        showModal: false,
        search: "",
        searchType: 1,
        mode: "",
        loading: false,
        item: {},
        policyStatus: {},
        osPolicyStatus: {},
        found: true,
        standalone: standalone,
        insPeriod: [],
        policies: [],
        osPolicies: [],
        policy: [],
        osPolicy: [],
        policyId: null,
        policyIndex: 0,
        policyCount: 0,
        showtext: false,
        isInsured: null,
        isInsuredPhone: null,
        regNumber: "",
        oldRegNumber: "",
        msg: "",
        recentAccident: {},
        recentAccidentView: {},
        uid: this.$store.state.user.id,
        callDate: null,
        compulsoryPeriod: "",
        voluntaryPeriod: "",
        compulsoryIndex: null,
        voluntaryIndex: null,
        compulsoryStatus: null,
        voluntaryStatus: null,
        compulsoryEndDate: null,
        voluntaryEndDate: null,
        recentAccidentDialog: false,
        labelWidth: '210px',
        accidentDateValue: {
          date: null,
          time: null,
        },

        rules: {
          driver: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          regionId: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          driverDescr: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          accidentCommUid: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          driverPhone: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          accidentDate: [
            {
              type: "date",
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
            { validator: validateDate, required: true, trigger: "change" },
          ],
          place: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          regNumber: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          injured: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          chainAccident: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          isProperty: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          isAnimal: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          approachedOffice: [
            {
              required: true,
              message: this.$t('Sütunmütləqdir'),
              trigger: "change",
            },
          ],
          // isWrongCall: [
          //   {
          //     required: true,
          //     message: this.$t('Sütunmütləqdir'),
          //     trigger: "change",
          //   },
          // ],
        },
        optCall: {
          disabledDate: (date) => {
            return new Date() <= date;
          },
        },
        optAccident: {
          disabledDate: (date) => {
            return this.callDate <= date;
          },
        },
      };
    },
    methods: {
      updateOppositeSide(car, property) {
        car[property] = event.target.value;
      },
      addOppositeSide() {

        const previousCount = this.oppositeSide.length;
        const currentCount = this.item.vehicleCount;

        if (currentCount < previousCount) {
          const lastIndex = this.oppositeSide.length - 1;
          this.deleteOppositeSide(lastIndex)
        }
        else if (currentCount > previousCount) {
          let lastId = 0;

          if (this.oppositeSide.length > 0) {
            lastId = this.oppositeSide[this.oppositeSide.length - 1].id;
          }
          this.oppositeSide.push({
            id: lastId + 1,
            accidentId: '',
            customBrandModel: '',
            orgName: '',
            insuranceCompId: null,
            regNumber: '',
            insuranceType: null,
            startDate: null,
            endDate: null,
            volStartDate: null,
            volEndDate: null,
            voluntaryPeriod: null,
            voluntaryStatus: null,
            voluntaryEndDate: null,
            voluntaryWarn: null,
          });
        }

      }
      ,
      deleteOppositeSide(index) {
        this.oppositeSide.splice(index, 1);
        const previousCount = this.oppositeSide.length;
        this.item.vehicleCount = this.oppositeSide.length;
      },

      start: function () {
        if (this.running) return;

        if (this.timeBegan === null) {
          this.reset();
          this.timeBegan = new Date();
        }
        if (this.timeStopped !== null) {
          this.stoppedDuration += (new Date() - this.timeStopped);
        }
        this.started = setInterval(this.clockRunning, 10);
        this.running = true;
      },
      reset: function () {
        this.running = false;
        clearInterval(this.started);
        this.stoppedDuration = 0;
        this.timeBegan = null;
        this.timeStopped = null;
        this.time = "00:00";
      },
      clockRunning: function () {
        var currentTime = new Date()
          , timeElapsed = new Date(currentTime - this.timeBegan - this.stoppedDuration)
          , min = timeElapsed.getUTCMinutes()
          , sec = timeElapsed.getUTCSeconds()
        this.timer =
          this.zeroPrefix(min, 2) + ":" +
          this.zeroPrefix(sec, 2)
      },
      zeroPrefix: function (num, digit) {
        var zero = '';
        for (var i = 0; i < digit; i++) {
          zero += '0';
        }
        return (zero + num).slice(-digit);
      },
      stop: function () {
        this.running = false;
        this.timeStopped = new Date();
        this.clearInterval(started);
      },
      closeDialog() {
      },
      onIsInsured() {
        if (this.isInsured)
          this.item.driver = this.item.insuredName;
        else
          this.item.driver = "";
      },
      onIsInsuredPhone() {
        if (this.isInsuredPhone) {
          this.item.driverPhone = this.item.phone;
        }
        else {
          this.item.driverPhone = "";
        }
      },
      new() {
        this.activeName = "person";
        this.searchRegNumber = "";
        this.item = new AccidentType();
        this.policyStatus = new PolicyStatusType();
        this.mode = "New";
        this.showModal = true;
        this.found = false;
        this.policyCount = null
        this.search = null;
        this.callDate = new Date();
        this.timeShow = true;
        this.item.isWrongCall = 0;
        this.item.accidentStage = 3;
        this.$nextTick(() => {
          if (this.$refs.policy) {
            this.$refs.policy.clearValidate();
          }
        });
      },
      edit(id) {
        this.searchRegNumber = "";
        this.loading = true;
        this.activeName = "person";
        this.mode = "Edit";
        this.showModal = true;
        this.search = null;
        this.policyCount = null;
        GetAccident(id).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.item = response.data.data;
            this.item.callDate = new Date(this.item.callDate);
            this.callDate = this.item.callDate;
            if (this.item.oldRegNumber !== '') {
              this.regNumberChange = true;
            }

            this.accidentDateValue.date = new Date(this.item.accidentDate);
            this.accidentDateValue.time = new Date(this.item.accidentDate);
            this.item.accidentDate = new Date(this.item.accidentDate);
            this.policyId = this.item.policyId;

            this.found = this.item.policyId === null;
            this.isInsured = null;
            this.isInsuredPhone = null;
            if (this.item.startDate)
              this.compulsoryPeriod = DateTimeReverseToString(this.item.startDate) + ' - ' + DateTimeReverseToString(this.item.endDate)
            else
              this.compulsoryPeriod = "";
            if (this.item.volStartDate)
              this.voluntaryPeriod = DateTimeReverseToString(this.item.volStartDate) + ' - ' + DateTimeReverseToString(this.item.volEndDate)
            else
              this.voluntaryPeriod = "";
            this.$nextTick(() => {
              if (this.$refs.policy) {
                this.$refs.policy.clearValidate();
              }
            });
          } else {
            this.showModal = false;
            this.$message({
              type: "warning",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
        GetOppositeSides(id).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.oppositeSide = response.data.data;
          } else {
            this.showModal = false;
            this.$message({
              type: "warning",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
      },
      onAccidentDateChange(date) {
        return this.callDate <= date;
      },

      onCallDateChange() {
        this.item.accidentdate = null;
      },
      checkForDuplicates(array) {
        const hasDuplicates = array.length !== new Set(array.map(item => item.regNumber)).size;


        return !hasDuplicates;
      },
      onsearchOs(index) {
        this.loading = true;

        if (!this.oppositeSide[index].regNumber || this.oppositeSide[index].regNumber === '') {
          this.loading = false;
          return;
        }

        let osItem = this.oppositeSide[index];
        for (let key in osItem) {
          if (key !== 'regNumber' && key !== 'id') {
            osItem[key] = null;
          }
        }

        if (this.item.regNumber === this.oppositeSide[index].regNumber) {
          this.$message({
            type: "error",
            message: this.$t('Sığortalı_ilə_qarşı_tərəf_eyni_ola_bilməz'),
          });
          this.oppositeSide[index].regNumber = null;
          this.loading = false;
          return;
        }

        if (!this.checkForDuplicates(this.oppositeSide)) {
          this.$message({
            type: "error",
            message: this.$t('Qarşı_tərəf_eyni_ola_bilməz'),
          });
          this.oppositeSide[index].regNumber = null;
          this.loading = false;
        } else {
          return new Promise(async (resolve, reject) => {
            let salesApiData, newsalesApiData;

            try {
              const salesApiResponse = await salesapi(this.oppositeSide[index].regNumber);

              salesApiData = salesApiresponse.data.data || [];

              const newsalesApiResponse = await newsalesapi(this.oppositeSide[index].regNumber);
              newsalesApiData = newsalesApiresponse.data.data || [];

              this.osPolicies = [...salesApiData, ...newsalesApiData];


              let currentDate = new Date();

              let isAnyPolicyValid = false;

              for (let i = 0; i < this.osPolicies.length; i++) {
                let policyEndDate = new Date(this.osPolicies[i].end_date);

                if (policyEndDate > currentDate) {
                  isAnyPolicyValid = true;
                  break;
                }
              }

              if (!isAnyPolicyValid) {
                this.$message({
                  type: "error",
                  message: this.$t('Qüvvədə_olan_sığorta_şəhadətnaməsi_tapılmadı'),
                });

                this.loading = false;
                return;
              }



              if (this.osPolicies.length !== 0) {
                let latestPolicy;

                for (let i = 0; i < this.osPolicies.length; i++) {
                  if (this.osPolicies[i].policy_type == 'İcbari') {
                    this.oppositeSide[index].startDate = this.osPolicies[i].start_date;
                    this.oppositeSide[index].endDate = this.osPolicies[i].end_date;
                    this.oppositeSide[index].orgName = this.$t('Azərsığorta_ASC');
                    this.oppositeSide[index].insuranceCompId = 1;
                  } else {
                    this.oppositeSide[index].volStartDate = this.osPolicies[i].start_date;
                    this.oppositeSide[index].volEndDate = this.osPolicies[i].end_date;
                    this.oppositeSide[index].voluntaryStatus = this.osPolicies[i].policy_status;

                    if (Date.parse(this.oppositeSide[index].volEndDate) < Date.parse(new Date)) {
                      this.oppositeSide[index].voluntaryWarn = true;
                    } else {
                      this.oppositeSide[index].voluntaryWarn = false;
                    }
                  }

                  if (this.osPolicies[i].policy_type == 'Kasko') {
                    if (!latestPolicy || Date.parse(this.osPolicies[i].start_date) > Date.parse(latestPolicy.start_date)) {
                      latestPolicy = this.osPolicies[i];
                      this.oppositeSide[index].voluntaryPeriod = DateTimeReverseToString(this.osPolicies[i].start_date) + ' - ' + DateTimeReverseToString(this.osPolicies[i].end_date);
                    }
                  }
                }

                if (!latestPolicy) {
                  for (let i = 0; i < this.osPolicies.length; i++) {
                    if (this.osPolicies[i].policy_type == 'İcbari') {
                      if (!latestPolicy || Date.parse(this.osPolicies[i].start_date) > Date.parse(latestPolicy.start_date)) {
                        latestPolicy = this.osPolicies[i];
                        this.oppositeSide[index].voluntaryPeriod = "";
                      }
                    }
                  }
                }

                this.osPolicy = latestPolicy;



                if (this.osPolicy.brand_name || this.osPolicy.model_name) {
                  this.oppositeSide[index].customBrandModel = this.osPolicy.brand_name + " " + this.osPolicy.model_name;
                } else {
                  this.oppositeSide[index].customBrandModel = "N/A";
                }

                this.loading = false;
                resolve();
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('Sığorta_şəhadətnaməsi_tapılmadı'),
                });

                this.loading = false;
                reject(this.$t('Sığorta_şəhadətnaməsi_tapılmadı'));
              }
            } catch (error) {
              this.$message({
                type: "error",
                message: this.$t('Səhvlik_baş_verdi_Zəhmət_olmasa_yenidən_cəhd_edin'),
              });

              this.loading = false;
              reject(error);
            }
          });
        }
      },


      handleAccidentView() {
        this.recentAccidentDialog = false;
        this.$refs["accident"].view(this.recentAccidentView);
      },
      getRecentAccident() {
        GetRecentAccident(this.searchRegNumber).then((response) => {
          if (response.data.data) {
            this.recentAccident = response.data.data;
            GetAccident(this.recentAccident.accidentId).then((response) => {
              this.loading = false;
              if (response.data.data) {
                this.recentAccidentView = rresponse.data.data;
              }
            });
            if (this.recentAccident !== null && Object.keys(this.recentAccident).length !== 0) {
              this.recentAccidentDialog = true;
            }
          } else {
            this.recentAccident = null;
          }
        });
      },

      redirectToAccident() {
        const url = this.$router.resolve(`/comm/accident/${this.recentAccident.accidentId}`).href;
        window.open(url, '_blank');
      }

      ,
      onsearch(regNumber) {

        if (!regNumber.trim()) {
          this.$message({
            type: "error",
            message: this.$t('Zəhmət_olmasa_dövlət_qeydiyyat_nişanını_daxil_edin'),
          });
          return;
        }

        this.getRecentAccident();

        this.$nextTick(() => {
          if (this.recentAccident !== null && Object.keys(this.recentAccident).length !== 0) {
            this.recentAccidentDialog = true;
          }
        });

        this.loading = true;
        this.isInsured = null;
        this.isInsuredPhone = null;
        this.item.phone = "";
        this.regNumber = this.item.regNumber;
        this.oldRegNumber = this.item.oldRegNumber;


        if (regNumber === '') {
          this.loading = false;
        }
        this.resetForm();
        return new Promise(async (resolve, reject) => {
          let salesApiData, newsalesApiData;

          try {
            const salesApiResponse = await salesapi(regNumber);
            salesApiData = salesApiresponse.data.data || [];

            const newsalesApiResponse = await newsalesapi(regNumber);
            newsalesApiData = newsalesApiresponse.data.data || [];

            this.policies = [...salesApiData, ...newsalesApiData];


            if (this.policies.length === 0) {
              this.$message({
                type: "error",
                message: this.$t('Sığorta_şəhadətnaməsi_tapılmadı'),
              });
            } else {
              this.processPolicies();
            }

            this.loading = false;
            resolve();
          } catch (error) {
            this.$message({
              type: "error",
              message: this.$t('Səhvlik_baş_verdi_Zəhmət_olmasa_yenidən_cəhd_edin'),
            });
            this.loading = false;
            reject(error);
          }
        });


      },
      processPolicies() {
        this.compulsoryIndex = null;
        this.voluntaryIndex = null;
        this.item.startDate = null;
        this.item.endDate = null;
        this.item.volStartDate = null;
        this.item.volEndDate = null;
        this.compulsoryPeriod = "";
        this.voluntaryPeriod = "";
        this.compulsoryStatus = "";
        this.voluntaryStatus = "";

        const today = new Date();

        for (var i in this.policies) {
          const policy = this.policies[i];
          const start = new Date(policy.start_date);
          const end = new Date(policy.end_date);

          if (policy.policy_type == 'İcbari') {
            if (this.compulsoryIndex === null || new Date(this.policies[this.compulsoryIndex].end_date) < end) {
              this.compulsoryIndex = i;
            }
          } else if (policy.policy_type == 'Kasko' || policy.policy_type == this.$t('Könüllü')) {
            if (this.voluntaryIndex === null || new Date(this.policies[this.voluntaryIndex].end_date) < end) {
              this.voluntaryIndex = i;
            }
          }
          // }
        }

        if (this.compulsoryIndex !== null) {
          const compulsoryPolicy = this.policies[this.compulsoryIndex];
          this.compulsoryPeriod = DateTimeReverseToString(compulsoryPolicy.start_date) + ' - ' + DateTimeReverseToString(compulsoryPolicy.end_date);
          this.item.startDate = compulsoryPolicy.start_date;
          this.item.endDate = compulsoryPolicy.end_date;
          this.item.insuranceCompId = 1;
          this.compulsoryStatus = compulsoryPolicy.policy_status;
          this.policyStatus.compulsoryStatus = this.compulsoryStatus;
          this.policyStatus.compulsoryPolicyId = compulsoryPolicy.policy_number;
        }

        if (this.voluntaryIndex !== null) {
          const voluntaryPolicy = this.policies[this.voluntaryIndex];
          this.voluntaryPeriod = DateTimeReverseToString(voluntaryPolicy.start_date) + ' - ' + DateTimeReverseToString(voluntaryPolicy.end_date);
          this.item.volStartDate = voluntaryPolicy.start_date;
          this.item.volEndDate = voluntaryPolicy.end_date;
          this.item.insuranceCompId = 1;
          this.voluntaryStatus = voluntaryPolicy.policy_status;
          this.policyStatus.voluntaryStatus = this.voluntaryStatus;
          this.policyStatus.voluntaryPolicyId = voluntaryPolicy.policy_number;
        }

        this.policy = this.policies[this.voluntaryIndex ? this.voluntaryIndex : this.compulsoryIndex];

        if (this.policy.reg_number) {
          this.policyStatus.regNumber = this.policy.reg_number;
          this.item.regNumber = this.policy.reg_number;
        } else {
          this.item.regNumber = null;
        }
        if (this.policy.policy_number) {
          this.item.policyNumber = this.policy.policy_number;
        } else {
          this.item.policyNumber = "N/A";
        }
        if (this.policy.insured_name) {
          this.item.insuredName = this.policy.insured_name;
        } else {
          this.item.insuredName = "N/A";
        }
        if (this.policy.brand_name || this.policy.model_name) {
          this.item.customBrandModel = this.policy.brand_name + " " + this.policy.model_name;
        } else {
          this.item.customBrandModel = "N/A";
        }
        if (this.policy.ident_number) {
          this.item.identNumber = this.policy.ident_number;
        } else {
          this.item.identNumber = "N/A";
        }
        if (this.policy.phone) {
          this.item.phone = this.policy.phone;
        } else {
          this.item.phone = null;
        }
        if (this.policy.production_year) {
          this.item.productionYear = this.policy.production_year;
        } else {
          this.item.productionYear = "N/A";
        }
        if (this.policy.vin) {
          this.item.vin = this.policy.vin;
        } else {
          this.item.vin = "N/A";
        }
        if (this.policy.branch_name) {
          this.item.branchName = this.policy.branch_name;
        } else {
          this.item.branchName = null;
        }
        if (this.policy.number_of_seats) {
          this.item.numberOfSeats = this.policy.number_of_seats;
        } else {
          this.item.numberOfSeats = 0;
        }
        this.item.policyId = this.policy.policy_number;
        this.item.personType = this.policy.person_type;
        this.item.insurancePeriod = DateTimeReverseToString(this.item.startDate) + " - " + DateTimeReverseToString(this.item.endDate);
        this.item.policyStatus = this.policy.policy_status;
      }
      ,
      notFoundChange() {
        this.resetForm();
        this.item.brandId = null;
        this.item.modelId = null;
        this.item.policyId = null;
        this.item.insurancePeriod = "";
        this.item.personType = null;
        this.item.startDate = null;
        this.item.endDate = null;
        this.item.policyNumber = null;
        this.item.identNumber = null;
        this.item.personType = null;
        this.item.insuredName = null;
        this.item.phone = null;
        this.item.brandModel = null;
        this.item.customBrandModel = null;

      },
      focusSearch(regNumber) {
        this.searchRegNumber = regNumber;
        this.onsearch(regNumber)
      },
      focusSearchOs(index) {
        this.onsearchOs(index)
      },

      inputDate() {
        if (this.$refs["datePicker"].dateVal && this.$refs["datePicker"].timeVal) {
          this.accidentDateValue.date = this.$refs["datePicker"].dateVal;
          this.accidentDateValue.time = this.$refs["datePicker"].timeVal;

          this.item.accidentDate = new Date(this.accidentDateValue.date.toString().substr(0, 16) + this.accidentDateValue.time.toString().substr(16, 44));

        }
        else {
          this.item.accidentDate = null;
          this.$nextTick(() => {
            if (this.$refs.policy) {
              this.$refs.policy.clearValidate();
            }
          });
        }
      },
      clickSave() {
        this.$refs["policy"].validate((valid) => {
          if (!valid) {
            this.$message({
              type: "warning",
              message: this.$t('Məlumatların_tam_və_düzgün_olmasını_yoxlayın'),
            });
            return false;
          } else {
            if (this.oppositeSide.some(e => e.regNumber === this.item.regNumber)) {
              this.$message({
                type: "warning",
                message: this.$t('Sığortalı_ilə_qarşı_tərəf_eyni_ola_bilməz'),
              });
              this.loading = false;
              return;
            }

            if (!this.checkForDuplicates(this.oppositeSide)) {
              this.$message({
                type: "error",
                message: this.$t('Qarşı_tərəf_eyni_ola_bilməz'),
              });
              this.loading = false;
              return;  // Stops the execution of the current function
            }
            for (let item of this.oppositeSide) {
              const propertiesToCheck = ['regNumber', 'insuranceCompId', 'customBrandModel'];


              const allEmpty = propertiesToCheck.every(property => {

                return !item[property] || (typeof item[property] === 'string' && item[property].trim() === "");
              });

              if (allEmpty && (!item.noInfo || item.noInfo !== 1)) {
                this.$message({
                  type: "error",
                  message: this.$t('Qarşı_tərəfin_məlumatı_qeyd_edilmeyib'),
                });
                this.loading = false;
                return false;
              }
            }

            this.saveAccident();

          }
        });
      },
      clickReject() {
        this.showModal = false;
        this.loading = false;
        if (this.mode = "New") {
          this.policyStatus.timer = this.timer;
          this.policyStatus.regNumber = this.item.regNumber;
          this.reset();
          this.timeShow = false;
          this.policyStatus.commandUserId = this.uid;
          PolicyStatusInsert(this.policyStatus).then((response) => {
            if (response.data.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {

              }
            } else {
              this.policyStatus = {};
            }
          });
        }

      },
      opened() {
        if (this.mode === 'New') {
          this.oppositeSide = []
          this.accidentDate = null;
          this.accidentDateValue.date = null;
          this.accidentDateValue.time = null;

        }
        this.reset();
        this.start();
        this.resetForm();
        this.addOppositeSide();
        this.regNumberChange = null;

      },
      resetForm() {
        this.$nextTick(() => {

          this.item.brandId = null;
          this.item.modelId = null;
          this.item.startDate = null;
          this.item.endDate = null;
          this.item.volStartDate = null;
          this.item.volStartDate = null;
          this.compulsoryPeriod = null;
          this.voluntaryPeriod = null;
          this.voluntaryStatus = null;
          this.compulsoryStatus = null
          this.item.policyId = null;
          this.item.insurancePeriod = "";
          this.item.personType = null;
          this.item.policyNumber = null;
          this.item.identNumber = null;
          this.item.insuredName = null;
          this.item.phone = null;
          this.item.brandModel = null;
          this.item.customBrandModel = null;
        })
      },
      saveAccident() {
        this.loading = true;
        let acc = Object.assign({}, this.item);
        acc.commandUserId = this.uid;
        acc.accidentDate = DateTimeToJson(this.item.accidentDate);
        acc.policyType = 1;
        acc.accidentStage = 3
        // acc.customBrandModel = this.item.brandId ? null : this.item.brandModel;

        if (this.mode === "New") {
          acc.callDate = DateTimeToJson(this.callDate);
          CreateAccident(acc).then((response) => {
            this.loading = false;
            if (response.data.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {

                this.showModal = false;
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
                let processItems = async () => {
                  for (let item of this.oppositeSide) {
                    item.accidentId = response.data.data.id;
                    let result = await CreateOppositeSide(item);

                    if (result.data && result.data.status !== 1) {
                      this.$message.error(result.data.message);
                    }
                  }
                }

                processItems();
                this.policyStatus.accidentId = response.data.data.value;
                this.policyStatus.timer = this.timer;

                this.policyStatus.commandUserId = this.uid;

                PolicyStatusInsert(this.policyStatus).then((response) => {
                  if (response.data.data) {
                    if (!response.data.isSuccess) {
                      this.$message({
                        type: "error",
                        message: response.data.errors[0],
                      });
                    } else {

                    }
                  } else {
                    this.policyStatus = {};
                  }
                });
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });

        } 
      },
      handleKeyDown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.showConfirmationDialog();
        }
      },
      showConfirmationDialog() {
        if (confirm(this.$t('Pəncərəni_bağlamaq_istəyirsiz'))) {
          this.showModal = false;
        }
      },
      updateLabelWidth() {
        if (window.innerWidth <= 1024) {
          this.labelWidth = '125px';
        } else {
          this.labelWidth = '210px';
        }
      }
    },
    mounted() {
      document.addEventListener('keydown', this.handleKeyDown);

    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.handleKeyDown);
      window.removeEventListener('resize', this.updateLabelWidth);

    },
    created() {
      this.updateLabelWidth();
      window.addEventListener('resize', this.updateLabelWidth);
    },
  };
</script>



<style lang="scss">
  .customDialog.el-dialog {
    z-index: 0;

    .el-dialog__body {
      padding: 0px 20px;
      color: var(--font-primary) !important;
      font-size: var(--font-large);
      word-break: break-all;
    }

    .el-dialog__header {
      padding: 10px 20px 10px;
    }
  }

  .mx-datepicker-popup {
    z-index: 3000;
  }
</style>